import { NgModule } from 'ng-metadata/core';
import {TagsSearchBarService} from './tagsSearchBar.service';
import {PrmTagsSearchBar} from './tagsSearchBar.directive';

@NgModule({
    declarations: [
        PrmTagsSearchBar
    ],
    providers: [
        TagsSearchBarService
    ],
    imports:[

    ]
})
export class TagsSearchBarModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsSearchBar/tagsSearchBar.module.ts